import { sortedLastIndexBy } from 'lodash'
import { IEvent } from '../../../models/Event'

// This function expects sorted events array
export default function(events: IEvent[], dateFrom, dateTo, excludedIds = []) {
  if (!events.length) {
    return true
  }

  const evIndex = sortedLastIndexBy(
    events,
    { startDate: dateFrom } as IEvent,
    re => {
      return +re.startDate
    },
  )

  const prevEvent =
    evIndex > 0 && !excludedIds.includes(events[evIndex - 1].id)
      ? events[evIndex - 1]
      : null
  const nextEvent =
    evIndex < events.length && !excludedIds.includes(events[evIndex].id)
      ? events[evIndex]
      : null

  return (
    (!prevEvent || +prevEvent.finishDate <= +dateFrom) &&
    (!nextEvent || !dateTo || +nextEvent.startDate >= +dateTo)
  )
}
